import DashboardChartWrapper from "./DashboardChartWrapper";

export default DashboardChartWrapper;
